// extracted by mini-css-extract-plugin
export default {"rating":"ZG-z","numberOfStars":"_G-z","count":"aH-z","barGraphSpacing":"bH-z","barGraph":"cH-z"};